import { ElementRef, Component, ChangeDetectionStrategy, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { WizBaseView, WizRoot, WizEventManager, WizEvent } from '@wizeoo/akm-component-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';

@Component({
  selector: 'root-view',
  templateUrl: './root.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootView extends WizBaseView implements OnInit, OnDestroy, AfterViewInit {
  
  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.wizAddListener();
  }

  ngOnDestroy(): void {
    this.wizRemoveListener();
  }

  wizAfterConstruct(): void {
  }

  public get showMe(): boolean {
    return !!Model.getInstance().connectedUser;
  }


  // cette vue n'est jamais removed, donc pas besoin du wizRemove...
  public wizAddListener() {
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.UPDATE_MODEL, this.updateViewDataModel);

    // modif de l'état d'un formulaire
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_STATE, this.updateViewDataWidgetState); 
    // reset de l'état des widgets sur navigation
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_END, this.widgetsClearState);
  }



  /**
   * alimentation du flag de changement de modèle dans ViewData sur interception d'un event "UPDATE"
   */
  updateViewDataModel(event: AlkEvent): void {
    ViewData.wizUpdateModel = event.data;
  }

  /**
   * modif d'état d'un form
   * @param event [this.uid, this._hasUpdate]
   */
  updateViewDataWidgetState(event: AlkEvent): void {
    ViewData.widgetStateMap.set(event.data[0], event.data[1]);
  }
  widgetsClearState(event: WizEvent): void {
    ViewData.widgetStateMap = new Map();
  }

}
